import {
  FormControl,
  FormField,
  RecordForm,
} from "@/components/forms/base-record-form";
import { MultiSelectCombobox } from "@/components/ui/multi-select-combobox";
import { useRecordForm } from "@/hooks/use-record-form";
import { cn } from "@/lib/utils";
import { Deal, Opportunity } from "@/types";

interface DealsFormProps {
  opportunities: Opportunity[];
  onSuccess?: (deal: Deal) => void;
  path: string;
  onCancel: () => void;
  initialData?: {
    name: string;
    opportunity_id: string;
    brief_inquiry_uid?: string;
    people_uids?: string[];
    company_uids?: string[];
  };
}

export function DealForm({
  opportunities,
  onSuccess,
  path,
  onCancel,
  initialData,
}: DealsFormProps) {
  const { data, setField, errors, isSubmitting, submit } = useRecordForm({
    path,
    param: "deal",
    initial: {
      name: initialData?.name || "",
      opportunity_id: initialData?.opportunity_id || "",
      brief_inquiry_uid: initialData?.brief_inquiry_uid || "",
      people_uids: initialData?.people_uids || [],
      company_uids: initialData?.company_uids || [],
    },
    onSuccess: (record) => onSuccess?.(record as unknown as Deal),
  });

  return (
    <RecordForm
      onSubmit={submit}
      onCancel={onCancel}
      isSubmitting={isSubmitting}
      submitLabel="Create deal"
    >
      <FormField
        label="Name"
        name="name"
        autoFocus
        value={data.name}
        onChange={(value) => setField("name", value)}
        errors={errors}
      />

      <FormControl label="Opportunity" name="opportunity_id" errors={errors}>
        <MultiSelectCombobox
          options={opportunities.map((opportunity) => ({
            value: opportunity.id.toString(),
            label: opportunity.name,
          }))}
          selectedValues={data.opportunity_id ? [data.opportunity_id] : []}
          onSelectionChange={(values) => setField("opportunity_id", values[0] ?? "")}
          placeholder="Select an opportunity…"
          searchPlaceholder="Search opportunities…"
          className={cn(errors.opportunity_id && "border-destructive")}
          singleSelect={true}
        />
      </FormControl>
    </RecordForm>
  );
}
